"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopNavigationMD = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const DropDown_1 = require("../../molecules/utils/DropDown");
const Logo_1 = require("../../molecules/utils/Logo");
const TopNavigationMD = (0, react_1.memo)((props) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { className: props.className, logoText: props.logoText || "", isSwitcher: !!props.contextSwitcher, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Logo_1.Logo, { text: props.logoText, logoSVG: props.logoSVG, link: props.logoLink }, void 0), (0, jsx_runtime_1.jsx)("div", { className: "switcher", children: props.contextSwitcher }, void 0)] }, void 0), props.isLogged && ((0, jsx_runtime_1.jsx)(DropDown_1.DropDown, { title: props.coachName || "", options: props.options || [] }, void 0)), props.dropdown && ((0, jsx_runtime_1.jsx)(DropDown_1.DropDown, { title: props.dropdown.title, options: props.dropdown.options }, void 0))] }, void 0));
});
exports.TopNavigationMD = TopNavigationMD;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  display: flex;
  height: 48px;
  justify-content: space-between;
  padding: ${({ theme: { spacings } }) => `${spacings.xl} ${spacings.xl}`};
  a {
    display: block;
  }
  & img {
    height: 27px;
    margin-left: ${({ theme, logoText }) => logoText && theme.spacings.xxs};
    width: auto;
  }
  & > div {
    display: flex;
    & > div:first-of-type {
      padding-right: ${({ theme }) => theme.spacings.m};
    }
    .switcher {
      align-items: center;
      border-left: 1px solid
        ${({ theme, isSwitcher }) => isSwitcher ? theme.colors.silverBase : "transparent"};
      display: flex;
      height: 48px;
    }
  }
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme: { spacings } }) => `${spacings.xl} ${spacings.m}`};
  }
  width: 100%;
`;
//# sourceMappingURL=NavigationTopMD.js.map